var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Frame"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 14",
    cx: 8,
    cy: 8,
    r: 6,
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 86",
    x: 8,
    y: 10.6641,
    width: 0.00666667,
    height: 0.00666667,
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 82",
    d: "M7.05719 5.06C7.31694 4.80025 7.6572 4.67007 7.99765 4.66947C8.33966 4.66887 8.68186 4.79905 8.94281 5.06C9.20316 5.32035 9.33333 5.66158 9.33333 6.00281C9.33333 6.34404 9.20316 6.68527 8.94281 6.94561C8.68186 7.20656 8.33966 7.33674 7.99765 7.33614L8 8.00281",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/questionCircle.b8a7867a23a520405d42cd7c87cde578.svg";
export { ForwardRef as ReactComponent };